export default function CTA() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img 
          src="https://public.readdy.ai/ai/img_res/4631e4e97eecc688e62c5306d463f565.jpg" 
          alt="Houston Skyline with Luxury Sprinter"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      </div>

      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto">
        <h2 className="text-5xl lg:text-6xl xl:text-7xl font-bold text-white uppercase tracking-wider mb-8 leading-tight">
          BOOK YOUR<br />LUXURY RIDE TODAY
        </h2>

        <p className="text-xl lg:text-2xl text-white mb-12 leading-relaxed">
          Professional Chauffeur Service | Mercedes Maybach Fleet<br />
          Available 24/7 Throughout Greater Houston
        </p>

        <button 
          onClick={() => scrollToSection('contact')}
          className="group relative inline-flex items-center bg-black text-white px-12 py-5 rounded-full text-lg font-bold hover:bg-gray-900 transition-all transform hover:scale-105 cursor-pointer whitespace-nowrap"
        >
          <div className="absolute -left-3 w-14 h-14 bg-orange-500 rounded-full flex items-center justify-center group-hover:bg-orange-600 transition-colors">
            <i className="ri-calendar-check-line text-2xl text-white"></i>
          </div>
          <span className="ml-8">RESERVE NOW</span>
          <i className="ri-arrow-right-up-line text-2xl ml-4"></i>
        </button>

        <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-8 text-white">
          <a href="tel:7139996733" className="flex items-center space-x-3 hover:text-teal-300 transition-colors cursor-pointer group">
            <div className="w-12 h-12 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center group-hover:bg-white/30 transition-colors">
              <i className="ri-phone-line text-xl"></i>
            </div>
            <div className="text-left">
              <div className="text-sm text-gray-300">Call Us</div>
              <div className="text-lg font-bold whitespace-nowrap">713-999-6733</div>
            </div>
          </a>

          <div className="flex items-center space-x-3">
            <div className="w-12 h-12 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center">
              <i className="ri-map-pin-line text-xl"></i>
            </div>
            <div className="text-left">
              <div className="text-sm text-gray-300">Serving</div>
              <div className="text-lg font-bold">Greater Houston</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
